<template>
  <ab-flow-base-cmp :movable="true" :block="block" class="image-explainer-editor-cmp">

    <ab-flow-link-connector :block="block" type="input" class="ev-run" event="run"/>

    <q-card class="card">

      <q-card-section class="bg-purple text-white q-py-sm">
        <template v-if="isServerApp">{{ title }}</template>
        <template v-else>
          {{ title }}: {{ syncResponse ? 'sync' : 'async' }}
        </template>
      </q-card-section>

    </q-card>

    <div class="results">
      <ab-flow-link-connector v-if="syncResponse" :block="block" type="output" event="data"/>
      <ab-flow-link-connector v-else :block="block" type="output" event="job-id"/>
      <ab-flow-link-connector :block="block" type="output" event="error"/>
    </div>

  </ab-flow-base-cmp>
</template>

<script>

import AbFlowBaseCmp from "ab-flow-designer/src/components/Designer/AbFlowBaseCmp";
import AbFlowLinkConnector from "ab-flow-designer/src/components/Designer/AbFlowLinkConnector";

export default {
  components: {AbFlowBaseCmp, AbFlowLinkConnector},
  inject: ['canvas', 'currentModule'],
  props: ['block'],
  name: "ImageExplainerEditorCmp",

  computed: {
    // Check if the current module is a server app
    isServerApp() {
      return this.currentModule?.currentModule?.type === 'server';
    },
    // Get the title property from the block
    title() {
      return this.block?.properties?.title || 'Image explainer';
    },
    // Get the syncResponse property from the block
    syncResponse() {
      return this.block?.properties?.syncResponse === 1 || this.isServerApp;
    },
  },
}

</script>

<style lang="scss">

.image-explainer-editor-cmp {
  position: relative;

  .card {
    max-width: 200px;
    word-wrap: break-word;
  }
  .ev-run {
    left: -12px;
    position: absolute;
    z-index: 1;
    top: calc(50% - 5px);
  }
  .results {
    right: -12px;
    position: absolute;
    z-index: 1;
    top: calc(50%);
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    row-gap: 6px;
  }
}

</style>
